import { put, call, all, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/invoices'
import {
  getCustomerAccounts,
  getInvoices,
  getInvoicesTypes,
  getInvoiceDownload
} from 'services'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { REQUEST_ERROR, INVOICES } from 'config/messages'
import arrayBufferToJSON from 'utils/arrayBufferToJSON'

const {
  INVOICES_ORIGIN_REQUEST,
  INVOICES_ORIGIN_SUCCESS,
  INVOICES_ORIGIN_ERROR,

  INVOICES_SECURITY_REQUEST,
  INVOICES_SECURITY_SUCCESS,
  INVOICES_SECURITY_ERROR,

  INVOICES_REQUEST,
  INVOICES_SUCCESS,
  INVOICES_ERROR,

  INVOICES_DOWNLOAD_REQUEST,
  INVOICES_DOWNLOAD_SUCCESS,
  INVOICES_DOWNLOAD_ERROR
} = ACTION_TYPES

export function *getCustomerAccountsSaga() {
  try {
    const response = yield call(getCustomerAccounts)
    yield put({ type: INVOICES_ORIGIN_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: INVOICES_ORIGIN_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getInvoicesSaga(payload) {
  try {
    const response = yield call(getInvoices, payload)

    if (response.status === 200) {
      yield put({ type: INVOICES_SUCCESS, payload: response })
    } else if (response.status === 204) {
      yield put({ type: INVOICES_ERROR, payload: response })
      yield put({
        type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
        payload: { text: INVOICES.NO_RESULT_ERROR, type: 'error' }
      })
    }
  } catch (err) {
    if (err.response && err.response.status === 400 && err.response.data.messages) {
      yield put({ type: INVOICES_ERROR, payload: err })
      yield put({
        type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
        payload: { text: err.response.data.messages.join(' '), type: 'error' }
      })
    } else {
      yield put({ type: INVOICES_ERROR, payload: err })
      yield put({
        type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
        payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
      })
    }
  }
}

export function *getInvoicesTypesSaga() {
  try {
    const response = yield call(getInvoicesTypes)
    yield put({ type: INVOICES_SECURITY_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: INVOICES_SECURITY_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getDownloadInvoice(payload) {
  try {
    const response = yield call(getInvoiceDownload, payload)

    const format = 'application/pdf'
    const fileName = `Invoice_${payload.payload.invoiceNumber}.pdf`

    yield put({ type: INVOICES_DOWNLOAD_SUCCESS, payload: { response, format, fileName } })
  } catch (err) {
    let text = REQUEST_ERROR.SERVER_ERROR.TITLE
    if (err.response) {
      const data = arrayBufferToJSON(err.response.data)
      if (data.messages) {
        text = data.messages.join(' ')
      }
    }
    yield put({ type: INVOICES_DOWNLOAD_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text, type: 'error' }
    })
  }
}

export default function *watchInvoices() {
  yield all([
    takeLatest(INVOICES_ORIGIN_REQUEST, getCustomerAccountsSaga),
    takeLatest(INVOICES_SECURITY_REQUEST, getInvoicesTypesSaga),
    takeLatest(INVOICES_REQUEST, getInvoicesSaga),
    takeLatest(INVOICES_DOWNLOAD_REQUEST, getDownloadInvoice)
  ])
}
